import React from 'react';
import {Outlet} from 'react-router-dom';

const CategorizationOutlet: React.FC = () => {
  return <Outlet />;
};
export default CategorizationOutlet;
